import { createContext } from "react";

const entityContext = createContext();

export default entityContext;
